/**
 * 桌面端顶部导航改为鼠标 hover 展开（含二级子菜单）。
 *
 * 主题原生行为是点击 <summary> 才展开 <details>，多一次点击才能看到分类。
 * 这里在不改动压缩后的 secondary.js 的前提下，用 document 级事件委托叠加 hover 行为，
 * 因此主题编辑器重新渲染 header section 之后依然生效。
 *
 * 触屏与窄屏（无 hover 能力或宽度小于桌面断点）完全不受影响，保持原生点击展开。
 */
(function () {
  var DESKTOP_MIN_WIDTH = 990; // 与主题 header 的桌面断点一致
  var CLOSE_DELAY_MS = 150; // 指针在相邻菜单项之间移动时的容错时间，避免闪烁
  var DROPDOWN_SELECTOR = 'header-menu details, products-mega-menu details';

  var closeTimer = null;

  function isDesktopHover() {
    return (
      window.matchMedia('(hover: hover) and (pointer: fine)').matches &&
      window.innerWidth >= DESKTOP_MIN_WIDTH
    );
  }

  function findDropdown(node) {
    return node instanceof Element ? node.closest(DROPDOWN_SELECTOR) : null;
  }

  /** 关闭所有下拉，但保留当前项本身及其祖先链（多级菜单需要父级一直展开） */
  function closeSiblings(current) {
    document.querySelectorAll(DROPDOWN_SELECTOR).forEach(function (details) {
      if (details === current || details.contains(current)) return;
      details.removeAttribute('open');
    });
  }

  /** 关闭该下拉及其内部所有子菜单，否则子菜单的 open 会残留到下次展开 */
  function closeWithDescendants(details) {
    details.removeAttribute('open');
    details.querySelectorAll('details[open]').forEach(function (child) {
      child.removeAttribute('open');
    });
  }

  document.addEventListener('mouseover', function (event) {
    if (!isDesktopHover()) return;
    var dropdown = findDropdown(event.target);
    if (!dropdown) return;

    clearTimeout(closeTimer);
    closeSiblings(dropdown);
    dropdown.setAttribute('open', '');
  });

  document.addEventListener('mouseout', function (event) {
    if (!isDesktopHover()) return;
    var dropdown = findDropdown(event.target);
    if (!dropdown) return;

    // 指针仍停留在同一下拉内部（子元素之间移动）时不关闭
    var movedTo = event.relatedTarget;
    if (movedTo instanceof Node && dropdown.contains(movedTo)) return;

    clearTimeout(closeTimer);
    closeTimer = setTimeout(function () {
      closeWithDescendants(dropdown);
    }, CLOSE_DELAY_MS);
  });

  // 桌面端下拉完全由 hover 控制，点击标题不再切换开关（避免 hover 已展开时点一下反而收起）
  document.addEventListener('click', function (event) {
    if (!isDesktopHover()) return;
    var summary = event.target instanceof Element ? event.target.closest('summary') : null;
    if (!summary || !summary.parentElement) return;
    if (!summary.parentElement.matches(DROPDOWN_SELECTOR)) return;
    event.preventDefault();
  });
})();
